import React from "react"
import moment from "moment"

import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom"
import { push, goBack } from "react-router-redux"
import "./Trips.css"
import Card from "../core/Card"
import SideNav from "../layout/SideNav"
import {
  EditIcon,
  MapIcon,
  Icon,
  TripsIcon,
  PaperclipIcon,
  NoteIcon,
  BackIcon,
  BriefcaseIcon,
  VehicleIcon,
  DotIcon,
  ForwardIcon,
  MergeIcon
} from "../core/icons"
import {
  Row,
  Col,
  Button,
  Select,
  DatePicker,
  Icon as AIcon,
  Tag,
  Tooltip,
  Popover,
  Checkbox,
  Dropdown,
  InputNumber,
  Tabs,
  Input,
  Radio
} from "antd"
import { connect } from "react-redux"
import {
  toggleTrip,
  loadMore,
  getTrips,
  updateRange,
  selectFilter,
  clearFilters,
  selectPlaceFilter,
  updateTrip,
  updateNote,
  nameThisPlace
} from "./actions"
import Summary from "./Summary"
import { withPreviousDate, getPurposes } from "./reducer"
import Line from "../core/Line"
import numeral from "numeral"
import styled, { ThemeProvider } from "styled-components"
import { Map } from "./MapCard"
import { Location } from "./Location"
const Option = Select.Option
const TabPane = Tabs.TabPane
const { TextArea } = Input

const VehiclesGroup = styled.div`
  padding: 20px;
  padding-bottom: 40px;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
`

const Vehicle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  flex-basis: 100px;
  flex-grow: 1;
  text-align: center;
  opacity: ${props => (props.isSelected ? 1 : 0.5)};

  &:hover {
    opacity: 1;
    ${"" /* > div {
      filter: none !important;
    } */};
  }
`

const EditLink = styled(Link)`
  position: absolute;
  bottom: 50px;
  right: 20px;
`

const vehicleLabel = (nickname, make, model) => {
  if (nickname) {
    return nickname
  }

  var name = make
  if (model) {
    name += " " + model
  }
  return name
}

export const VehiclePicker = connect((state, ownProps) => {
  return {
    vehicle_id: ownProps.vehicle_id,
    vehicleOptions: state.models.vehicles.map(v => ({
      title: vehicleLabel(v.nickname, v.make, v.model),
      value: v.id,
      icon_name: v.icon_name
    })),
    ...ownProps
  }
})(({ onVehicleSelect, vehicleOptions, vehicle_id }) => (
  <VehiclesGroup>
    {vehicleOptions.length > 0 ? (
      vehicleOptions.map(v => (
        <Vehicle
          key={v.value}
          onClick={() => onVehicleSelect(v.value)}
          isSelected={v.value == vehicle_id}
        >
          <div
            style={{
              filter:
                v.value == vehicle_id
                  ? "drop-shadow(1px 1px 1px lightgrey)"
                  : "hue-rotate(75deg) saturate(40%) opacity(90%)"
            }}
          >
            <Icon
              color={"#1abc9c"}
              type={v.icon_name || "Vehicle"}
              height="40"
              width="40"
            />
          </div>
          <div>{v.title}</div>
        </Vehicle>
      ))
    ) : (
      <Vehicle style={{ opacity: 1 }}>
        <Icon type={"Vehicle"} height="40" width="40" />
        <Button>
          <Link to="/account/vehicles/new">
            <AIcon type="plus" />
            Add a vehicle
          </Link>
        </Button>
      </Vehicle>
    )}

    {vehicleOptions.length > 0 && (
      <Tooltip title="Add or Edit Vehicles">
        <EditLink to="/account/vehicles">
          <AIcon type="edit" />
        </EditLink>
      </Tooltip>
    )}
  </VehiclesGroup>
))



// WEBPACK FOOTER //
// ./src/trips/VehiclePicker.js